import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: 'form[appFocusOnFirstErrorField]',
    standalone: true,
})
export class FocusOnFirstErrorFieldDirective {

    @HostListener('submit')
    onFocusOnFirstErrorField(): void {
        const invalidClassName = 'ng-invalid';
        const childTags = ['INPUT', 'TEXTAREA', 'MAT-SELECT']; // Массив допустимых тегов для установки фокуса

        const invalidElements = document.querySelectorAll('.ng-invalid');

        for (const childEl of Array.from(invalidElements)) {
            if (childEl.tagName === 'MAT-SLIDE-TOGGLE' && childEl.classList.contains(invalidClassName)) {
                (childEl.querySelector('button'))?.focus(); // применяем фокус к элементу button
            }

            if (childEl.tagName === 'MAT-CHECKBOX' && childEl.classList.contains(invalidClassName)) {
                (childEl.querySelector('input'))?.focus(); // применяем фокус к элементу input
            }

            if (childEl.classList.contains(invalidClassName) && childTags.includes(childEl.tagName)) {
                (childEl as HTMLElement).focus();
                break;
            }
        }
    }
}
